// DSST 스픽(Spick) 버전 전용 효과음
// - 외부 음원 파일 없이 Web Audio 로 짧은 톤을 합성한다.
// - AudioContext 는 사용자 제스처(게임 시작 버튼) 이후에만 재생되며, 실패해도 게임 진행에는 영향이 없다.

let audioCtx: AudioContext | null = null;

function getAudioContext(): AudioContext | null {
  if (typeof window === 'undefined') return null;
  const Ctor =
    window.AudioContext ??
    (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
  if (!Ctor) return null;
  if (!audioCtx) {
    try {
      audioCtx = new Ctor();
    } catch {
      return null;
    }
  }
  if (audioCtx.state === 'suspended') {
    audioCtx.resume().catch(() => {});
  }
  return audioCtx;
}

// 게임 시작 버튼(사용자 제스처) 안에서 호출해 오디오 컨텍스트를 미리 깨워둔다.
export function unlockAudio(): void {
  getAudioContext();
}

interface ToneOptions {
  freq: number;
  duration: number;
  gain: number;
  type?: 'sine' | 'square' | 'triangle' | 'sawtooth';
  delay?: number;
  endFreq?: number;
}

function playTone({ freq, duration, gain, type = 'sine', delay = 0, endFreq }: ToneOptions): void {
  const ctx = getAudioContext();
  if (!ctx) return;
  try {
    const now = ctx.currentTime + delay;
    const osc = ctx.createOscillator();
    const gainNode = ctx.createGain();
    osc.type = type;
    osc.frequency.setValueAtTime(freq, now);
    if (endFreq) {
      osc.frequency.exponentialRampToValueAtTime(endFreq, now + duration);
    }
    gainNode.gain.setValueAtTime(0.0001, now);
    gainNode.gain.exponentialRampToValueAtTime(gain, now + 0.012);
    gainNode.gain.exponentialRampToValueAtTime(0.0001, now + duration);
    osc.connect(gainNode);
    gainNode.connect(ctx.destination);
    osc.start(now);
    osc.stop(now + duration + 0.03);
  } catch {
    // 사운드 실패는 게임 진행에 영향을 주지 않는다
  }
}

// 정답: 짧고 명확한 성공음
export function playCorrectSound(): void {
  playTone({ freq: 659.25, duration: 0.11, gain: 0.05 });
}

// 오답: 매우 약하고 낮은 피드백 (알람처럼 들리지 않게)
export function playWrongSound(): void {
  playTone({ freq: 220, duration: 0.16, gain: 0.04, endFreq: 170 });
}

// 카운트다운 틱: 짧고 낮은 톤
export function playTickSound(): void {
  playTone({ freq: 440, duration: 0.08, gain: 0.035 });
}

// 시작 신호: 카운트다운 종료 시 밝은 두 음
export function playStartSound(): void {
  playTone({ freq: 659.25, duration: 0.1, gain: 0.05, delay: 0 });
  playTone({ freq: 987.77, duration: 0.16, gain: 0.05, delay: 0.09 });
}